/**
 * The asset listing provider contains methods for operating on an existing list of assets or validation assets
 * (currently only the latter). This allows us to have a unified source of logic/truth for filtering/sorting
 * assets on the frontend.
 */

import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { RecognitionFrame } from './frame';
import { Class, ClassProvider, NOTHING_I_KNOW_IDENTIFIER } from './class';

@Injectable()
export class AssetListingProvider extends BaseProvider {
    constructor(private classProvider: ClassProvider) {
        super();
    }

    public applyRecognitionFramesFilter(
        recognitionFrames: RecognitionFrame[],
        classID: string,
        filteringResults: string,
        classesTable: Map<string, Class>
    ): RecognitionFrame[] {
        let filteredAssets: RecognitionFrame[] = [];

        if (!recognitionFrames || recognitionFrames.length === 0) {
            return [];
        }

        if (classID || filteringResults !== 'none') {
            filteredAssets = recognitionFrames.filter((asset: RecognitionFrame): boolean => {
                let matchFilter = true;

                if (classID) {
                    if (classID == NOTHING_I_KNOW_IDENTIFIER) {
                        matchFilter = this.classProvider.isClassNothingIKnow(asset.predictedClass, false);
                    } else if (asset.actualClass) {
                        const actualClass = classesTable.get(asset.actualClass);
                        matchFilter = actualClass !== undefined && actualClass.id === classID;
                    } else if (asset.predictedClass) {
                        const predictedClass = classesTable.get(asset.predictedClass);
                        matchFilter = predictedClass !== undefined && predictedClass.id === classID;
                    }
                }

                if (matchFilter && filteringResults !== 'none') {
                    if (filteringResults === 'correct') {
                        matchFilter = asset.actualClass === asset.predictedClass;
                    } else if (filteringResults === 'incorrect') {
                        matchFilter = asset.actualClass !== asset.predictedClass;
                    }
                }

                return matchFilter;
            });
        } else {
            // If nothing's being filtered out, return a shallow copy of the array to prevent
            // referencing errors.
            filteredAssets = recognitionFrames.slice(0);
        }

        return filteredAssets;
    }
}



// WEBPACK FOOTER //
// ./src/providers/asset_listing.ts